module.exports = __webpack_public_path__ + "dcb24ca98d03643e7625650d948c26a8.png";